module.exports = __webpack_public_path__ + "static/img/sequence-3.a60beae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/sequence-3.jpg
// module id = 73rr
// module chunks = 0